import { render } from "./ShowMotif.vue?vue&type=template&id=a143bafe"
import script from "./ShowMotif.vue?vue&type=script&lang=js"
export * from "./ShowMotif.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__